module.exports = __webpack_public_path__ + "static/media/thirdFloorSide.9be50842.png";